var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20001 5.59995C3.20001 4.27412 4.27418 3.19995 5.60001 3.19995H17.6C18.0418 3.19995 18.4 3.55812 18.4 3.99995C18.4 4.44178 18.0418 4.79995 17.6 4.79995H5.60001C5.15784 4.79995 4.80001 5.15778 4.80001 5.59995C4.80001 6.04212 5.15784 6.39995 5.60001 6.39995H12.8C13.2418 6.39995 13.6 6.75812 13.6 7.19995C13.6 7.64178 13.2418 7.99995 12.8 7.99995H5.60001C4.27418 7.99995 3.20001 6.92578 3.20001 5.59995Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 6.4001H4.80001L3.20001 5.6001V18.4001C3.20001 19.7257 4.27441 20.8001 5.60001 20.8001H19.2C20.084 20.8001 20.8 20.0841 20.8 19.2001V8.0001C20.8 7.1161 20.084 6.4001 19.2 6.4001ZM17.6 15.2001C16.716 15.2001 16 14.4841 16 13.6001C16 12.7161 16.716 12.0001 17.6 12.0001C18.484 12.0001 19.2 12.7161 19.2 13.6001C19.2 14.4841 18.484 15.2001 17.6 15.2001Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 15.2C16.716 15.2 16 14.484 16 13.6C16 12.716 16.716 12 17.6 12C18.484 12 19.2 12.716 19.2 13.6C19.2 14.484 18.484 15.2 17.6 15.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.f5c981fa21d5512346404bd99fcfe002.svg";
export { ForwardRef as ReactComponent };